import { useGetDynamicDomainLink } from '@hooks/use-get-dynamic-domain-link'
import { useTrackExternalLink } from '@hooks/use-track-external-link'
import { getLinkTargetAttribute } from '@utils/is-webview'
import { type SyntheticEvent } from 'react'

export type usePdfLinkPropsReturn = {
  href: string
  onClick: (event: SyntheticEvent) => void
  component: 'a'
  target: string
}

export const usePdfLinkProps = (url: string): usePdfLinkPropsReturn => {
  const trackExternalLink = useTrackExternalLink()
  const getDynamicPrivateLink = useGetDynamicDomainLink('private')

  return {
    href: getDynamicPrivateLink(url),
    onClick: trackExternalLink,
    target: getLinkTargetAttribute(),
    component: 'a',
  }
}
